import { Component, inject, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { PasSelectComponent, PasSelectOption } from '@porsche-aftersales/frontend-toolbox';

import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { TableViewCustomModel } from '../common/model/table-view-custom-model';
import { TableViewCustomModelOption } from '../common/model/table-view-custom-model-option';
import { TvaCustomService } from '../tva-custom.service';

@Component({
  selector: 'app-tva-custom-selection',
  templateUrl: './tva-custom-selection.component.html',
  imports: [FormsModule, ReactiveFormsModule, TranslatePipe, PasSelectComponent],
})
export class TvaCustomSelectionComponent implements OnInit {
  public readonly tvaCustomService = inject(TvaCustomService);
  public readonly fb = inject(UntypedFormBuilder);

  public formGroupSelection: UntypedFormGroup;

  private readonly systemDefaultTableView: TableViewCustomModel = null;

  public constructor() {
    this.tvaCustomService.setTvaCustomSelectionComponent(this);
  }

  public ngOnInit(): void {
    // Set selected tableView to systemDefault
    this.formGroupSelection = new UntypedFormGroup({
      formControlSelection: new UntypedFormControl({ value: this.systemDefaultTableView, disabled: true }),
    });
  }

  /**
   * Select customized tableView from selectionBox and adjust the table accordingly.
   * @param tabView
   * On PivotMode the columnOrder will have no affect. See https://www.ag-grid.com/javascript-grid/pivoting/ Saving & Restoring Column State with Pivot
   */
  public onSelectTableView(tabView: TableViewCustomModelOption | PasSelectOption | any): void {
    this.tvaCustomService.gridApi.updateGridOptions({ pivotMode: tabView.pivotMode });

    this.tvaCustomService.gridApi.setFilterModel(JSON.parse(tabView.filterModel));
    this.tvaCustomService.gridApi.applyColumnState({
      state: JSON.parse(tabView.columnState),
      applyOrder: true,
    });
    this.tvaCustomService.doCheckResetDefaultTableViewActivability();
  }
}
